import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import apiRequest from "../../../../utils/admin/apiRequest";
import InputField from "../../../ui/form/InputField";
import Button from "../../../ui/utils/Button";

const EditCountry = ({ data, closeModal, callback }) => {
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.editCountry);
  const formik = useFormik({
    initialValues: {
      name: data?.name,
      code: data?.code,

    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      code: Yup.string().required("Code is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const response = await post({ data: { body: values, id: data?._id } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Update Country</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">
          <InputField
            name="name"
            label="Country Name"
            placeholder="Enter code"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.name}
            error={formik.touched.name && formik.errors.name}
          />
          
            <InputField
            name="code"
            label="Country code"
            placeholder="Enter Country Code"
            value={formik.values.code}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.code && formik.errors.code}
            serverError={serverErrors?.code}
          />
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Updating..."
            isLoading={loading}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditCountry;
